import React, { useContext, useEffect, useRef, useState } from "react";
import Input from "components/Elements/Input";
import Select from "react-select";
import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  getUser,
  saveUser,
  createUsers,
  deleteUser,
  sendUserEmail,
  sendGroupEmail,
  sendUserNotification,
  sendGroupNotification,
} from "../../services/users";
import { FormToggle, FormSubLabel, FormElement, FormLabel } from "components/StyledElements";
import { AppContext } from "../../contexts/AppContext";
import { EditUserDialog } from "../Dialogs/EditUserDialog";

DataTable.use(DT);

const compedOptions = [
  { label: "False", value: false },
  { label: "True", value: true },
];

const emailNotificationOptions = [
  { label: "False", value: false },
  { label: "True", value: true },
];

const EditUserModal = NiceModal.create(({ public_id }) => {
  const { selectedClient, hasPlatformFeature } = useContext(AppContext);
  const [newUser, setNewUser] = useState(public_id === null);
  const [savingUser, setSavingUser] = useState(false);
  const [user, setUser] = useState(null);
  const [name, setName] = useState(null);
  const formRef = useRef(null);
  const userRef = useRef(null);
  const modal = useModal();

  useEffect(() => {
    if (public_id) {
      getUser(public_id).then((user) => {
        setName(`${user.firstname} ${user.lastname}`);
        setUser(user);
      });
    } else {
      setNewUser(true);
      setUser(null);
    }
  }, [public_id]);

  useEffect(() => {
    console.log("!!! USER AFTER: ", user);
  }, [user]);

  const hide = (e) => {
    modal.remove();
  };

  const handleCompedChange = (comped) => {
    const u = { ...user };
    u.comped_subscription = comped.value;
    setUser(u);
  };

  const handleEmailNotificationChange = (enabled) => {
    const u = { ...user };
    u.email_notifications_enabled = enabled.value;
    setUser(u);
  };

  const handleChange = (e) => {
    console.log("!!! HANDLE CHANGE: ", e.target);
    const { name, value } = e.target;
    const u = { ...user };
    u[name] = value;
    setUser(u);
  };


  const save = async (e) => {
    console.log("!!! SELECTED CLIENT: ", selectedClient);
    setSavingUser(true);
    user.client = selectedClient;
    user.client.public_id = selectedClient.id;
    user.user_type = "user";
    console.log("!!! USER TO SAVE: ", user);
    const updatedUser = await saveUser(user);
    console.log("!!! SAVE UPDATED USER: ", updatedUser);
    modal.resolve(updatedUser);
    Swal.fire({
      title: "Success",
      text: "User saved successfully",
      icon: "success",
      button: "OK",
      confirmButtonText: "OK",
    }).then((result) => {
      setSavingUser(false);
      modal.remove();
    });
  };

  return (
    <>
      <div className="w-5/12 h-auto force-height-90 force-center items-center flex overflow-x-hidden overflow-y-hidden overflow-hidden fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-full my-6 mx-auto max-w-3xl">
          {/*content*/}
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
            {/*header*/}
            <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
              <h3 className="text-3xl font-semibold">
                {newUser ? "New User" : `Edit ${name}`}
              </h3>
              <button
                className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                onClick={hide}
              >
                <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                  ×
                </span>
              </button>
            </div>
            {/*body*/}
            <div
              className="relative p-6 flex-auto overflow-y-auto"
              style={{ maxHeight: "70vh" }}
            >
              <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
                <form ref={formRef} autoComplete="off">
                  <label>ID</label>
                  <Input
                    label="ID"
                    type="text"
                    placeholder="ID"
                    name="id"
                    value={user?.public_id ?? ""}
                    onChange={handleChange}
                    disabled={true}
                  />
                  <label>First Name</label>
                  <Input
                    label="First Name"
                    type="text"
                    placeholder="First Name"
                    name="firstname"
                    value={user?.firstname ?? ""}
                    onChange={handleChange}
                  />
                  <label>Last Name</label>
                  <Input
                    label="Last Name"
                    type="text"
                    placeholder="Last Name"
                    name="lastname"
                    value={user?.lastname ?? ""}
                    onChange={handleChange}
                  />
                  <label>Email Address</label>
                  <Input
                    label="Email"
                    type="text"
                    placeholder="Email"
                    name="email"
                    value={user?.email ?? ""}
                    onChange={handleChange}
                  />
                  <label>Password</label>
                  <Input
                    label="Password"
                    type="password"
                    placeholder="Password"
                    name="password"
                    value={user?.password ?? ""}
                    onChange={handleChange}
                    autoComplete="new-password"
                  />
                  {
                    hasPlatformFeature("groups") && (
                      <>
                        <label>Group</label>
                        <Input
                          label="Group"
                          type="text"
                          placeholder="Group"
                          name="user_group"
                          value={user?.user_group ?? ""}
                          onChange={handleChange}
                          autoComplete="off"
                        />
                      </>)
                  }
                  {
                    hasPlatformFeature("subscriptions") && (
                      <>
                        <label>Comped Subscription</label>
                        <Select
                          label="Comped Subscription"
                          placeholder="Comped Subscription"
                          name="comped_subscription"
                          value={
                            user?.comped_subscription
                              ? {
                                label: "True",
                                value: true,
                              }
                              : {
                                label: "False",
                                value: false,
                              }
                          }
                          options={compedOptions}
                          onChange={handleCompedChange}
                        />
                      </>
                    )
                  }
                  {
                    hasPlatformFeature("email notifications") && (
                      <>
                        <label>Email Notifications</label>
                        <Select
                          label="Email Notifications"
                          placeholder="Email Notifications"
                          name="email_notifications_enabled"
                          value={
                            user?.email_notifications_enabled
                              ? {
                                label: "True",
                                value: true,
                              }
                              : {
                                label: "False",
                                value: false,
                              }
                          }
                          options={emailNotificationOptions}
                          onChange={handleEmailNotificationChange}
                        />
                      </>)
                  }
                  {
                    selectedClient?.user_fields?.map((field) => (
                      <div key={field.public_id}>
                        <label>{field.title}</label>
                        <Input
                          label={field.title}
                          type={field.type}
                          placeholder={field.title}
                          name={field.public_id}
                          value={user?.client_field_values?.[field.public_id] ?? ""}
                          onChange={(e) => {
                            let value = e.target.value;
                            if (field.type === "phone_number") {
                              // make the format (123) 456-7890 while typing
                              const cleaned = value.replace(/\D/g, "");
                              // // format the cleaned number
                              if (cleaned.length > 3 && cleaned.length <= 6) {
                                value = `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
                              } else if (cleaned.length > 6) {
                                value = `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
                              }
                            }
                            const u = { ...user };
                            if (!u.client_field_values) {
                              u.client_field_values = {};
                            }

                            u.client_field_values[field.public_id] = value;
                            setUser(u);
                          }}
                          autoComplete="off"
                        />
                      </div>
                    ))
                  }
                </form>
              </div>
            </div>
            <div className="relative p-6 flex-auto"></div>
            {/*footer*/}
            <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
              {!savingUser ? (
                <button
                  className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                  type="button"
                  onClick={hide}
                >
                  Close
                </button>
              ) : null}
              <button
                className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
                onClick={save}
                disabled={
                  savingUser || JSON.stringify(user) === userRef.current
                }
                style={{
                  opacity: JSON.stringify(user) === userRef.current ? 0.5 : 1,
                }}
              >
                {savingUser ? (
                  <>
                    <i className="fas fa-circle-notch fa-spin"></i>{" "}
                    Processing...
                  </>
                ) : (
                  <>Save</>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
});

NiceModal.register("edit-user", EditUserModal);

const EmailModal = NiceModal.create(({ public_id, dt, navigate }) => {
  const { selectedClient } = useContext(AppContext);
  const [sendingEmail, setSendingEmail] = useState(false);
  const [sendingNotification, setSendingNotification] = useState(false);
  const [manual, setManual] = useState(false);
  const [fromEmail, setFromEmail] = useState("");
  const [toEmails, setToEmails] = useState("");
  const [userGroups, setUserGroups] = useState("");
  const [visibleUsers, setVisibleUsers] = useState(false);
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [user, setUser] = useState(null);
  const [sendAsCampaign, setSendAsCampaign] = useState(false);
  const [campaignTitle, setCampaignTitle] = useState("");
  const modal = useModal();

  useEffect(() => {
    if (public_id) {
      getUser(public_id).then((user) => {
        setUser(user);
      });
    } else {
      setManual(true);
    }
  }, [public_id]);

  const hide = (e) => {
    modal.remove();
  };

  const send = async (e) => {
    setSendingEmail(true);

    if (manual) {
      let emails = toEmails ? toEmails.split(",").map((email) => email.trim()) : [];
      let userIds = [];
      let groups = userGroups ? userGroups.split(",").map((group) => group.trim()) : [];

      if (visibleUsers) {
        console.log("!!! SENDING EMAIL TO VISIBLE USERS ONLY", dt);
        const visibleUsers = dt.rows({ search: "applied" }).data().toArray();
        console.log("!!! VISIBLE USERS: ", visibleUsers);
        //emails = visibleUsers.map((user) => user[1]);
        emails = [];
        userIds = visibleUsers.map((user) => user[0]);
        console.log("!!! EMAILS: ", emails);
      }

      const results = await sendGroupEmail(
        selectedClient.id,
        emails,
        userIds,
        groups,
        subject,
        message,
        fromEmail,
        sendAsCampaign,
        campaignTitle
      );
      setSendingEmail(false);
      console.log("!!! RESULTS: ", results);
      if (results.success) {
        const successMessage = sendAsCampaign ? "Email campaign created successfully. Emails will be sent out shortly." : "Email sent successfully";
        Swal.fire({
          title: "Success",
          text: successMessage,
          icon: "success",
          button: "OK",
          confirmButtonText: "OK",
        }).then((result) => {
          modal.remove();

          if (sendAsCampaign) {
            if (results.emailcampaign) {
              navigate(`/admin/email-campaign/${results.emailcampaign.public_id}`);
            } else {
              Swal.fire({
                title: "Error",
                text: "Email campaign was created but we were unable to retrieve the campaign details.",
                icon: "error",
                button: "OK",
                confirmButtonText: "OK",
              });
            }
          }
        });
      } else {
        Swal.fire({
          title: "Error",
          text: results.message,
          icon: "error",
          button: "OK",
          confirmButtonText: "OK",
        }).then((result) => {
          modal.remove();
        });
      }
    } else {
      const results = await sendUserEmail(
        user.public_id,
        user.email,
        subject,
        message
      );
      setSendingEmail(false);
      if (results.success) {
        Swal.fire({
          title: "Success",
          text: "Email sent successfully",
          icon: "success",
          button: "OK",
          confirmButtonText: "OK",
        }).then((result) => {
          modal.remove();
        });
      } else {
        Swal.fire({
          title: "Error",
          text: results.message,
          icon: "error",
          button: "OK",
          confirmButtonText: "OK",
        }).then((result) => {
          modal.remove();
        });
      }
    }
  };

  const sendNotification = async (e) => {
    setSendingNotification(true);

    if (manual) {
      console.log("!!! SENDING NOTIFICATION TO VISIBLE USERS ONLY", dt);
      setSendingNotification(true);
      if (visibleUsers) {
        console.log("!!! SENDING EMAIL TO VISIBLE USERS ONLY", dt);
        const users = dt.rows({ search: "applied" }).data().toArray();
        console.log("!!! VISIBLE USERS: ", visibleUsers);
        const user_ids = users.map((user) => user[0]).join(", ");
        console.log("!!! USER IDS: ", user_ids);
        const results = await sendGroupNotification(
          selectedClient.id,
          user_ids,
          subject,
          message
        );
        if (results.success) {
          Swal.fire({
            title: "Success",
            text: "Notifications sent successfully",
            icon: "success",
            button: "OK",
            confirmButtonText: "OK",
          }).then((result) => {
            modal.remove();
          });
        } else {
          Swal.fire({
            title: "Error",
            text: results.message,
            icon: "error",
            button: "OK",
            confirmButtonText: "OK",
          }).then((result) => {
            modal.remove();
          });
        }
      } else {
        Swal.fire({
          title: "Error",
          text: "Notifications can only be sent to visible users",
          icon: "error",
          button: "OK",
          confirmButtonText: "OK",
        }).then((result) => {
          setSendingNotification(false);
        });
      }
      setSendingNotification(false);
      return;
    } else {
      const results = await sendUserNotification(
        user.public_id,
        subject,
        message
      );
      setSendingNotification(false);
      if (results.success) {
        Swal.fire({
          title: "Success",
          text: "Notification sent successfully",
          icon: "success",
          button: "OK",
          confirmButtonText: "OK",
        }).then((result) => {
          modal.remove();
        });
      } else {
        Swal.fire({
          title: "Error",
          text: results.message,
          icon: "error",
          button: "OK",
          confirmButtonText: "OK",
        }).then((result) => {
          modal.remove();
        });
      }
    }
  };

  return (
    <>
      <div className="w-5/12 h-auto force-height-90 force-center items-center flex overflow-x-hidden overflow-y-hidden overflow-hidden fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-full my-6 mx-auto max-w-3xl">
          {/*content*/}
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
            {/*header*/}
            <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
              <h3 className="text-3xl font-semibold">
                {user ? `Email ${user.email}` : "Email Users"}
              </h3>
              <button
                className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                onClick={hide}
              >
                <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                  ×
                </span>
              </button>
            </div>
            {/*body*/}
            <div
              className="relative p-6 flex-auto overflow-y-auto"
              style={{ maxHeight: "70vh" }}
            >
              <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
                <form>
                  <FormElement>
                    <FormLabel label={`Send as Campaign (${sendAsCampaign ? "Yes" : "No"})`} style={{ margin: 0 }} />
                    <FormToggle
                      checked={sendAsCampaign ?? false}
                      onChange={(e) => {
                        setSendAsCampaign(e.target.checked);
                      }}
                    />
                    <FormSubLabel label="Sending as a campaign will create a trackable asychronous email campaign that you can use to follow the status of the campaign. You'll be redirected to the email campaign page on success." />
                  </FormElement>
                  {manual ? (
                    <>
                      {
                        sendAsCampaign && (
                          <>
                            <label>Campaign Title</label>
                            <Input
                              label="Campaign Title"
                              type="text"
                              placeholder="Campaign Title"
                              name="campaign_title"
                              value={campaignTitle ?? ""}
                              onChange={(e) => {
                                setCampaignTitle(e.target.value);
                              }}
                            />
                          </>)
                      }
                      <label>From</label>
                      <Input
                        label="From"
                        type="text"
                        placeholder="From"
                        name="from_email"
                        value={fromEmail ?? ""}
                        onChange={(e) => {
                          setFromEmail(e.target.value);
                        }}
                      />
                      <label>Visible Users</label>
                      <Select
                        label="Visible Users Only"
                        placeholder="No"
                        name="visible_users"
                        value={
                          !visibleUsers
                            ? { label: "No", value: false }
                            : { label: "Yes", value: true }
                        }
                        options={[
                          { label: "Yes", value: true },
                          { label: "No", value: false },
                        ]}
                        onChange={(e) => {
                          setVisibleUsers(e.value);
                        }}
                      />
                      {!visibleUsers && (
                        <>
                          <label>To Emails (csv)</label>
                          <Input
                            label="To"
                            type="text"
                            placeholder="To"
                            name="to"
                            value={toEmails ?? []}
                            onChange={(e) => {
                              setToEmails(e.target.value);
                            }}
                          />
                          <label>Groups (csv)</label>
                          <Input
                            label="Groups"
                            type="text"
                            placeholder="Groups"
                            name="groups"
                            value={userGroups ?? []}
                            onChange={(e) => {
                              setUserGroups(e.target.value);
                            }}
                          />
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      <label>Email Address</label>
                      <Input
                        label="Email Address"
                        type="text"
                        placeholder="Email Address"
                        name="email"
                        value={user?.email ?? ""}
                        disabled={true}
                      />
                    </>
                  )}
                  <label>Subject</label>
                  <Input
                    label="Subject"
                    type="text"
                    placeholder="Subject"
                    name="subject"
                    value={subject ?? ""}
                    onChange={(e) => {
                      setSubject(e.target.value);
                    }}
                  />
                  <label>Message</label>
                  <Input
                    label="Message"
                    type="textarea"
                    placeholder="Message"
                    name="message"
                    value={message ?? ""}
                    onChange={(e) => {
                      setMessage(e.target.value);
                    }}
                    style={{ height: "200px" }}
                  />
                </form>
              </div>
            </div>
            <div className="relative p-6 flex-auto"></div>
            {/*footer*/}
            <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
              {!sendingEmail ? (
                <button
                  className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                  type="button"
                  onClick={hide}
                >
                  Close
                </button>
              ) : null}
              <button
                className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
                onClick={send}
                disabled={sendingEmail || !subject || !message}
                style={{
                  opacity: !subject || !message ? 0.5 : 1,
                }}
              >
                {sendingEmail ? (
                  <>
                    <i className="fas fa-circle-notch fa-spin"></i> Sending...
                  </>
                ) : (
                  <>Send</>
                )}
              </button>
              <button
                className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
                onClick={sendNotification}
                disabled={sendingNotification || !subject || !message}
                style={{
                  opacity: !subject || !message ? 0.5 : 1,
                }}
              >
                {sendingNotification ? (
                  <>
                    <i className="fas fa-circle-notch fa-spin"></i> Sending...
                  </>
                ) : (
                  <>Send Notification</>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
});

NiceModal.register("email-user", EmailModal);

const UploadUsersModal = NiceModal.create(() => {
  const { selectedClient } = useContext(AppContext);
  const [creatingUsers, setCreatingUsers] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const modal = useModal();


  const hide = (e) => {
    modal.remove();
  };

  const save = async (e) => {
    setCreatingUsers(true);

    const results = await createUsers(usersList);
    if (results.success) {
      modal.resolve(results.users);
      Swal.fire({
        title: "Success",
        text: "Users created",
        icon: "success",
        button: "OK",
        confirmButtonText: "OK",
      }).then((result) => {
        setCreatingUsers(false);
        modal.remove();
      });
    } else {
      Swal.fire({
        title: "Error",
        text: results.message,
        icon: "error",
        button: "OK",
        confirmButtonText: "OK",
      }).then((result) => {
        modal.remove();
      });
    }
  };

  return (
    <>
      <div className="w-5/12 h-auto force-height-90 force-center items-center flex overflow-x-hidden overflow-y-hidden overflow-hidden fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-full my-6 mx-auto max-w-3xl">
          {/*content*/}
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
            {/*header*/}
            <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
              <h3 className="text-3xl font-semibold">Upload Users File</h3>
              <button
                className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                onClick={hide}
              >
                <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                  ×
                </span>
              </button>
            </div>
            {/*body*/}
            <div
              className="relative p-6 flex-auto overflow-y-auto"
              style={{ maxHeight: "70vh" }}
            >
              <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
                <form>
                  <label>Users File</label>
                  <Input
                    label="CSV File"
                    type="file"
                    placeholder="CSV File"
                    name="csv_file"
                    onChange={(e) => {
                      console.log("!!! FILE: ", e.target.files[0]);
                      const file = e.target.files[0];
                      const reader = new FileReader();
                      reader.onload = (event) => {
                        const text = event.target.result;
                        const lines = text.split("\n");
                        const users = lines
                          .filter((line) => line !== "")
                          .map((line) => {
                            const [
                              email,
                              name,
                              user_group,
                              is_comped,
                            ] = line.split(",");
                            if (!email || !name || !user_group || !is_comped) {
                              return false;
                            }
                            return {
                              email: email.trim(),
                              name: name.trim(),
                              user_group: user_group.trim(),
                              is_comped: is_comped.trim() === "yes" ? 1 : 0,
                              client: {
                                ...selectedClient,
                                public_id: selectedClient.id,
                              },
                              user_type: "user",
                            };
                          });
                        setUsersList(users);
                      };
                      reader.readAsText(file);
                    }}
                  />
                  <div>
                    File format is csv with the fields: email, name, group,
                    is_comped (yes/no)
                  </div>
                </form>
              </div>
            </div>
            <div className="relative p-6 flex-auto"></div>
            {/*footer*/}
            <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
              {!creatingUsers ? (
                <button
                  className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                  type="button"
                  onClick={hide}
                >
                  Close
                </button>
              ) : null}
              <button
                className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
                onClick={save}
                disabled={creatingUsers}
                style={{
                  opacity: !usersList || usersList.lenght === 0 ? 0.5 : 1,
                }}
              >
                {creatingUsers ? (
                  <>
                    <i className="fas fa-circle-notch fa-spin"></i> Saving...
                  </>
                ) : (
                  <>Save</>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
});

NiceModal.register("upload-users-file", UploadUsersModal);

const UsersTable = ({ users = [], hideTitle = false, hideButtons = false, onUpdated = () => { }, mode = null, onSelect = () => { }, onFilter = () => { } }) => {
  const tableRef = useRef(null);
  const [localUsers, setLocalUsers] = useState(users);
  const [deleting, setDeleting] = useState(false);
  const [showEditUserDialog, setShowEditUserDialog] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    setLocalUsers(users);
    const publicIds = users.map((user) => user.public_id);
    onFilter(publicIds);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [users]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (tableRef.current) {
        const dt = tableRef.current.dt();
        dt.on("search.dt", () => {
          const rows = dt.rows({ search: "applied" }).data().toArray();
          const publicIds = rows.map((row) => row[0]);
          onFilter(publicIds);
        });
        clearInterval(interval);
      } else {
        console.log("!!! TABLE REF IS NULL");
      }
    }, 10);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  window.formatDate = (date) => {
    const inputDate = new Date(date);

    const pad = (n) => n.toString().padStart(2, "0");

    const formattedDate =
      `${pad(inputDate.getDate())}-${pad(
        inputDate.getMonth() + 1
      )}-${inputDate.getFullYear()} ` +
      `${pad(inputDate.getHours())}:${pad(inputDate.getMinutes())}:${pad(
        inputDate.getSeconds()
      )} ` +
      `GMT${inputDate.toTimeString().slice(9, 14)} (${inputDate
        .toTimeString()
        .match(/\(([^)]+)\)/)[1]
        .split(" ")
        .map((w) => w[0])
        .join("")})`;
    return formattedDate;
  };

  window.edit = (public_id) => {
    console.log("!!! USER EDIT: ", public_id);
    setSelectedUserId(public_id);
    setShowEditUserDialog(true);
    return;
  };

  window.delete = (public_id) => {
    console.log("!!! USER DELETE: ", public_id);
    if (tableRef.current) {
      const table = tableRef.current.dt();
      const row = table.row((idx, data) => data[0] === public_id);

      if (row) {
        const data = row.data();
        Swal.fire({
          title: "Are you sure?",
          text: `You are trying to delete ${data[1]}. You won't be able to revert this!`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete the user!",
        }).then(async (result) => {
          if (result.value) {
            setDeleting(true);
            const response = await deleteUser(public_id);
            console.log("!!! DELETE RESPONSE: ", response);
            const newLocalUsers = [...localUsers].filter(
              (user) => user.public_id !== public_id
            );

            onUpdated(newLocalUsers);

            setDeleting(false);
            Swal.fire("Deleted!", "The user has been deleted.", "success");
          }
        });
      }
    }
  };

  window.selectedUsers = new Set();
  window.onSelectUsers = onSelect;

  window.email = (public_id) => {
    NiceModal.show("email-user", {
      public_id: public_id,
      dt: tableRef.current ? tableRef.current.dt() : null,
      navigate: navigate,
    });
  };

  const uploadUsersFile = () => {
    NiceModal.show("upload-users-file").then((users) => {
      const newLocalUsers = [...localUsers];
      users.forEach((user) => {
        newLocalUsers.push(user);
      });
      onUpdated(newLocalUsers);
    });
  };

  const tableData = localUsers.map((user) => {
    const fieldValues = {
      id: user.id,
      public_id: user.public_id,
      client_id: user.client_id,
      client: user.client,
      email: user.email,
      user_type: user.user_type,
      group: user.user_group ?? "",
      name: `${user.firstname} ${user.lastname ?? ""}`,
      user_group: user.user_group ?? "",
      subscription_status: user.subscription_status
        ? user.subscription_status
        : user.comped_subscription
          ? "comped"
          : "",
      subscription_period_ends_at: user.subscription_period_ends_at
        ? new Date(user.subscription_period_ends_at)
        : "",
      email_notifications_enabled: user.email_notifications_enabled
        ? "True"
        : "False",
      last_login: user.last_login ? new Date(user.last_login) : "",
      created_at: user.created_at ? new Date(user.created_at) : "",
      full_actions: `<div style="display: flex; flex-direction: row;"><div style="display: flex; flex-direction: row;"><button style="width: 40px; display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 20px; color: black;" onClick="window.edit('${user.public_id}')" class="bg-emerald-400 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">✎</button></div><div style="display: flex; flex-direction: row;"><button style="width: 40px; display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 20px; color: black;" onClick="window.email('${user.public_id}')" class="bg-orange-400 text-white active:bg-orange-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">&#x2709;</button></div><div style="display: flex; flex-direction: row;"><button style="width: 40px; display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 16px; color: black;" onClick="window.delete('${user.public_id}')" class="bg-red-400 text-white active:bg-red-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">X</button></div>`,
      select_email_actions: `<div data-public-id="${user.public_id}" data-selected="false" style="display: flex; flex-direction: row;">
          <button style="width: 40px; display: flex; flex-direction: column; align-items: center; justify-content: center; background-color: rgba(50, 166, 91, 0.3);" onClick="const p = this.parentNode; const ds = p.dataset; ds.selected=ds.selected==='false'?'true':'false'; console.log('CLICKED', this.parentNode.dataset.publicId); if(ds.selected==='true') { window.selectedUsers.add(ds.publicId); this.style.backgroundColor='rgba(50, 166, 91, 1)';} else {window.selectedUsers.delete(ds.publicId); this.style.backgroundColor='rgba(50, 166, 91, 0.3)';}; window.onSelectUsers(window.selectedUsers); " class="bg-green-400 text-white active:bg-green-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="m19.75 7.018l-9.257 9.257a1 1 0 0 1-1.414 0L4.25 11.446"/></svg></button>  
        </div>`
    }

    if (mode === "select-email") {
      return [
        fieldValues.public_id,
        fieldValues.client,
        fieldValues.email,
        fieldValues.name,
        fieldValues.select_email_actions,
      ];
    } else if (mode === "select") {
      return [
        fieldValues.public_id,
        fieldValues.name,
        fieldValues.email,
        fieldValues.select_email_actions,
      ];
    } else {
      return [
        fieldValues.public_id,
        fieldValues.email,
        fieldValues.name,
        fieldValues.user_type,
        fieldValues.user_group,
        fieldValues.subscription_status,
        /*fieldValues.subscription_period_ends_at,
        fieldValues.email_notifications_enabled,*/
        fieldValues.last_login,
        fieldValues.created_at,
        fieldValues.full_actions,
      ];
    }
    /*
    return [
      user.public_id,
      user.email,
      `${user.firstname} ${user.lastname ?? ""}`,
      user.user_group ?? "",
      user.subscription_status
        ? user.subscription_status
        : user.comped_subscription
          ? "comped"
          : "",
      user.subscription_period_ends_at
        ? new Date(user.subscription_period_ends_at)
        : "",
      user.email_notifications_enabled ? "True" : "False",
      user.last_login ? new Date(user.last_login) : "",
      user.created_at ? new Date(user.created_at) : "",
      `<div style="display: flex; flex-direction: row;"><div style="display: flex; flex-direction: row;"><button style="width: 40px; display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 20px; color: black;" onClick="window.edit('${user.public_id}')" class="bg-emerald-400 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">✎</button></div><div style="display: flex; flex-direction: row;"><button style="width: 40px; display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 20px; color: black;" onClick="window.email('${user.public_id}')" class="bg-orange-400 text-white active:bg-orange-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">&#x2709;</button></div><div style="display: flex; flex-direction: row;"><button style="width: 40px; display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 16px; color: black;" onClick="window.delete('${user.public_id}')" class="bg-red-400 text-white active:bg-red-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">X</button></div>`,
    ];
      */
  });

  const getTableFormat = (mode) => {
    if (mode === "select-email") {
      return (
        <>
          <th>ID</th>
          <th>Client</th>
          <th>Email</th>
          <th>Name</th>
          <th>Actions</th>
        </>
      );
    } else if (mode === "select") {
      return (
        <>
          <th>ID</th>
          <th>Name</th>
          <th>Email</th>
          <th>Actions</th>
        </>
      );
    } else {
      return (
        <>
          <th>ID</th>
          <th>Email</th>
          <th>Name</th>
          <th>Type</th>
          <th style={{ width: "50px" }}>Group</th>
          <th style={{ width: "150px" }}>Status</th>
          <th>Last Login</th>
          <th>Created At</th>
          <th>Actions</th>
        </>
      );
    }
  }

  return (
    <div>
      { !hideTitle ? (
        <div style={{ fontSize: "32px", fontWeight: "bold" }}>
          Users
          <span
            style={{
              fontSize: "20px",
              fontWeight: "normal",
              marginLeft: "10px",
              cursor: "pointer",
            }}
            onClick={() => {
              window.edit("");
            }}
          >
            <i className="fas fa-plus"></i>
          </span>
          <span
            style={{
              fontSize: "20px",
              fontWeight: "normal",
              marginLeft: "10px",
              cursor: "pointer",
            }}
            onClick={() => {
              window.email("");
            }}
          >
            <i className="fas fa-envelope"></i>
          </span>
          <span
            style={{
              fontSize: "20px",
              fontWeight: "normal",
              marginLeft: "10px",
              cursor: "pointer",
            }}
            onClick={() => {
              uploadUsersFile();
            }}
          >
            <i className="fas fa-upload"></i>
          </span>
        </div>
      ) : null}
      <div style={{ fontSize: "16px", fontStyle: "italic", fontWeight: "normal" }}>
        {localUsers.length.toLocaleString()} users
        </div>
      <DataTable
        ref={tableRef}
        data={tableData}
        className="display"
        options={{
          responsive: true,
          select: true,
          pageLength: 25,
          order: [[mode === "select-email" ? 2 : 7, "desc"]],
        }}
      >
        <thead>
          <tr>{getTableFormat(mode)}</tr>
        </thead>
      </DataTable>
      {deleting ? (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "10px",
            transform: "translate(-50%, -50%)",
            zIndex: 1000,
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
            border: "1px solid #ccc",
          }}
        >
          <i
            className="fas fa-circle-notch fa-spin"
            style={{ fontSize: "50px", textAlign: "center" }}
          ></i>
          <div style={{ fontSize: "20px", fontWeight: "bold" }}>
            Deleting...
          </div>
        </div>
      ) : null}

      <EditUserDialog
        show={showEditUserDialog}
        user_id={selectedUserId}
        onClose={(user) => {
          console.log("!!! UPDATED USER: ", user);
          if (user) {
            const newLocalUsers = [...localUsers];
            let foundUser = false;
            newLocalUsers.forEach((item) => {
              if (item.public_id === user.public_id) {
                item.firstname = user.firstname;
                item.lastname = user.lastname;
                item.email = user.email;
                item.user_group = user.user_group;
                item.comped_subscription = user.comped_subscription;
                item.email_notifications_enabled =
                  user.email_notifications_enabled;
                item.last_login = user.last_login;
                item.created_at = user.created_at;
                /*item.created_at = numericDateTimeFormatter.format(
                  user.created_at
                );*/
                foundUser = true;
              }
            });

            if (!foundUser) {
              newLocalUsers.push(user);
            }
            onUpdated(newLocalUsers);
          }
          setShowEditUserDialog(false);
        }}
      />
    </div>
  );
};

export default UsersTable;
